









































































































































import { Component, Emit, Prop } from "vue-property-decorator";
import Vue from "vue";
import DotCounter from "@/components/weighting/DotCounter.vue";
import { getModule } from "vuex-module-decorators";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Viewpoints from "@/store/modules/Viewpoints";
import Users from "@/store/modules/Users";
import { FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import Weighting from "@/store/modules/Weighting";
import _ from "lodash";

const workspaceOptionsModule = getModule(WorkspaceOptions)
const viewpointsModule = getModule(Viewpoints)
const usersModule = getModule(Users);
const modellingModule = getModule(Modelling)
const weightingModule = getModule(Weighting);
@Component({
    components: {DotCounter}
})
export default class TableWeightInput extends Vue {

    @Prop()
    actionType!: string;

    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    totalDots!: number;

    private selectedColumnElement: FactorGroup | null = null;

    get columnWidth() {
        return workspaceOptionsModule.choiceColumnWidth;
    }

    get currentUserId() {
        return usersModule.currentUserProfile.userId
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get viewpointFactors() {
        return viewpointsModule.viewpointFactorResources;
    }

    get viewpointsWeightingDotsMap() {
        return weightingModule.viewpointGroupDots;
    }

    get orderedRows(): FactorGroup[] {
        return this.tableFactorGroup.childrenIds
            .map(f => this.factors[f] as FactorGroup)
            .filter(f => f && f.groupTypeDefinition.type === 'TABLE_ROW')
    }

    get orderedColumns(): FactorGroup[] {
        return this.tableFactorGroup.childrenIds
            .map(f => this.factors[f] as FactorGroup)
            .filter(f => f && f.groupTypeDefinition.type === 'TABLE_COLUMN')
    }

    get tableGrid() {
        let grid: any = {};
        this.orderedColumns.forEach(c => {
            grid[c.id] = {};
            this.orderedRows.forEach(r => {
                let factorIds = _.intersection(c.childrenIds, r.childrenIds)
                if (factorIds.length === 1) {
                    grid[c.id][r.id] = factorIds[0]
                }
            })
        })
        return grid;
    }

    private getScoresColumnText() {
        if (this.selectedColumnElement) {
            return this.factors[this.selectedColumnElement.id].name;
        }
        return ''
    }

    private getGroupCount(groupTreeElement: FactorGroup) {
        return (groupTreeElement.childrenIds || []).length
    }


    private async changeParentsDots(viewpointId: string, factorResourceId: string, newValue: number) {
        await weightingModule.updateViewpointWeightsWithoutSubmit({
            viewpointId: viewpointId,
            factors: {[factorResourceId]: newValue}
        })

        this.dotsChanged(viewpointId);
    }

    private async changeGroupDots(viewpointId: string, factorResource: FactorGroup, addedDotValue: number) {
        let remainingDots = addedDotValue;
        let changeValue = addedDotValue < 0 ? -1 : 1
        let resources = factorResource.childrenIds
            .sort((a: string, b: string) => this.getFactorResourceDotCount(viewpointId, a)
                - this.getFactorResourceDotCount(viewpointId, b))
        let removedOne = true;

        let newFactorsWeights: any = {};
        //Go through each factor and remove one at a time
        while (remainingDots != 0 && removedOne) {
            removedOne = false;
            for (let factorResource of resources as any) {
                if (this.getFactorResourceDotCount(viewpointId, factorResource) + changeValue >= 0) {
                    newFactorsWeights[factorResource] = this.getFactorResourceDotCount(viewpointId, factorResource) + changeValue;
                    remainingDots = remainingDots - changeValue;
                    removedOne = true;
                }
            }
        }
        await weightingModule.updateViewpointWeightsWithoutSubmit({
            viewpointId: viewpointId,
            factors: newFactorsWeights
        })

        this.dotsChanged(viewpointId);
    }

    private getFactorResourceDotCount(viewpointId: string, factorResourceId: string) {
        let viewpointFactor = this.viewpointFactors[viewpointId][factorResourceId]
        if (viewpointFactor && viewpointFactor.numWeightingDots != null) {
            return viewpointFactor.numWeightingDots;
        }
        return this.factors[factorResourceId].numWeightingDots || 1;
    }

    @Emit('dots-changed')
    private dotsChanged(viewpointId: string) {
        return viewpointId
    }
}
